import React, { useEffect } from "react";
import { EditOutlined } from "@ant-design/icons";
import { Form, Input, Button } from "antd";
import TextArea from "antd/es/input/TextArea";
import ButtonWrapper from "../../../views/components/reuseComp/ButtonWrapper";

interface ContactData {
  heading: string;
  subtext: string;
  address: string;
  phone: string;
  email: string;
}

const ContactDetail: React.FC<{
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  handleCancel: () => void;
  handleSave: () => void;
  form: any;
  contactData?: ContactData;
  loading?: boolean;
}> = ({
  isEditing,
  setIsEditing,
  handleCancel,
  handleSave,
  form,
  loading,
  contactData,
}) => {
  useEffect(() => {
    if (contactData) {
      form.setFieldsValue({
        
          heading: contactData?.heading || "",
          subtext: contactData?.subtext || "",
          address: contactData?.address || "",
          phone: contactData?.phone || "",
          email: contactData?.email || "",
      
      });
    } else {
      form.resetFields();
    }
  }, [contactData]);

  return (
    <div>
      {!isEditing ? (
        <>
          <div className="rounded-[20px] overflow-hidden hidden sm:block">
            <table className="min-w-full">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="py-3 px-4 text-left">Heading</th>
                  <th className="py-3 px-4 text-left">Subtext</th>
                  <th className="py-3 px-4 text-left">Contact Details</th>
                  <th className="py-3 px-4 text-right">Action</th>
                </tr>
              </thead>

              <tbody>
                {contactData ? (
                  <tr className="bg-[#F9F9F9] border-b">
                    <td className="py-3 px-4">{contactData.heading}</td>
                    <td className="py-3 px-4">{contactData.subtext}</td>
                    <td className="py-3 px-4">
                      <div className="">
                        <li className="list-disc font-medium">Address: </li>
                        {contactData?.address}
                        <li className="list-disc font-medium">Phone: </li>{" "}
                        {contactData?.phone}
                        <li className="list-disc font-medium">Email: </li>{" "}
                        {contactData?.email}
                      </div>
                    </td>
                    <td className="py-3 px-4 text-right">
                      <EditOutlined
                        onClick={() => setIsEditing(true)}
                        className="cursor-pointer text-primary text-[20px]"
                      />
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center py-6 bg-[#f9f9f9]">
                      <Button type="dashed" onClick={() => setIsEditing(true)}>
                        Add Contact Detail
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="sm:hidden mt-3 space-y-4">
            <div className="bg-[#F9F9F9] border border-gray-200 rounded-lg p-4 shadow-sm space-y-3">
              <div>
                <div>
                  <b className="text-primary">Heading:</b>
                </div>
                <p>{contactData?.heading}</p>
              </div>

              <div>
                <div>
                  <b className="text-primary">Subtext:</b>
                </div>
                <p>{contactData?.subtext || "—"}</p>
              </div>

              <div>
                <div>
                  <b className="text-primary">Contact Details:</b>
                </div>
                <div className="px-5">
                  <li className="list-disc font-medium">Address: </li>
                  {contactData?.address}
                  <li className="list-disc font-medium">Phone: </li>
                  {contactData?.phone}
                  <li className="list-disc font-medium">Email: </li>
                  {contactData?.email}
                </div>
              </div>
              <div>
                <EditOutlined
                  onClick={() => setIsEditing(true)}
                  className="cursor-pointer text-primary text-[18px]"
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <div>
          <div className="bg-[#F9F9F9] p-4 sm:p-6 rounded-xl shadow-sm">
            <Form layout="vertical" form={form}>
              <Form.Item
                label="Heading"
                name={"heading"}
                valuePropName="value"
                rules={[{ required: true, message: "enter heading" }]}
              >
                <Input placeholder="enter heading..." />
              </Form.Item>

              <Form.Item
                label="Subtext"
                name={"subtext"}
                valuePropName="value"
                rules={[{ required: true, message: "enter subtext" }]}
              >
                <TextArea rows={3} placeholder="enter subtext..." />
              </Form.Item>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <Form.Item label="Address" name={"address"}>
                  <Input placeholder="enter address..." />
                </Form.Item>

                <Form.Item label="Phone" name={"phone"}>
                  <Input placeholder="enter phone number" />
                </Form.Item>

                <Form.Item label="Email" name={"email"}>
                  <Input placeholder="enter email..." />
                </Form.Item>
              </div>
            </Form>
          </div>

          <div className="flex gap-3 mt-7">
            <ButtonWrapper
              type="primary"
              onClick={handleSave}
              loading={loading}
            >
              Save
            </ButtonWrapper>
            <ButtonWrapper onClick={handleCancel}>Cancel</ButtonWrapper>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactDetail;
